import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Drawer } from 'antd';
import { useLocation } from 'react-router-dom';

import { IReduxState } from 'src/store';
import { useIsCompactLayout } from 'src/hooks';

import Header from './components/header/header.component';
import Footer from './components/footer/footer.component';
import Menu from './components/sider/sider.component';

import { IProps } from './layout.type';
import styles from './layout.style';

const LayoutComponent: React.FC<IProps> = (props) => {
  const { children, user } = props;
  const [collapsed, setCollapsed] = useState(true);
  const [visible, setVisible] = useState(false);
  const { Sider } = Layout;
  const isCompactLayout = useIsCompactLayout();
  const location = useLocation();

  useEffect(() => {
    if (isCompactLayout) {
      setVisible(false);
    }
  }, [location.pathname, isCompactLayout]);

  const handleDrawer = () => {
    if (isCompactLayout) {
      setVisible((prev) => !prev);
      setCollapsed(false);
      return;
    }
    setCollapsed((prev) => !prev);
  };

  if (!user) {
    return (
      <Layout style={{ position: 'relative', minHeight: '100vh' }}>
        <Layout style={styles.contentLayoutLogin}>{children}</Layout>
      </Layout>
    );
  }

  if (isCompactLayout) {
    return (
      <Layout style={{ position: 'relative', minHeight: '100vh' }}>
        <Drawer
          placement="left"
          open={visible}
          closable={false}
          onClose={() => setVisible(false)}
          width={280}
          styles={{ body: { padding: 0 } }}
        >
          <Menu collapsed={false} />
        </Drawer>
        <Layout
          style={{
            ...styles.contentLayout,
            overflowX: 'hidden',
          }}
        >
          <Header handleDrawer={handleDrawer} user={user} />
          <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            {children}
          </div>
          <Footer />
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout style={{ position: 'relative', minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={styles.sider}
      >
        <Menu collapsed={collapsed} />
      </Sider>
      <Layout style={styles.contentLayout}>
        <Header handleDrawer={handleDrawer} user={user} />
        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {children}
        </div>
        <Footer />
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(LayoutComponent);
